import { useCallback, useEffect } from 'react';
import { SESSION_STATE } from '../sessionProvider.constants';
import { TSessionState } from '../sessionProvider.types';

type TUsePageUnloadProps = {
  sessionState: TSessionState;
  clearSessionFirebase: () => void | Promise<void>;
};

export const usePageUnload = ({
  sessionState,
  clearSessionFirebase,
}: TUsePageUnloadProps) => {
  // If the user is not fully authenticated when the page is reloaded,
  // clear firebase session
  const handleBeforeUnload = useCallback(() => {
    if (sessionState !== SESSION_STATE.AUTHENTICATED) {
      void clearSessionFirebase();
    }
  }, [clearSessionFirebase, sessionState]);

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload]);
};
